import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { RoleProvider } from "@/contexts/RoleContext";
import { ClientRoute, AdminRoute } from "@/components/RouteGuards";
import PreviewBanner from "@/components/PreviewBanner";
import InstallPrompt from "@/components/InstallPrompt";
import LanguageGateway from "@/pages/LanguageGateway";
import Landing from "@/pages/Landing";
import SignInPage from "@/pages/SignInPage";
import SignUpPage from "@/pages/SignUpPage";
import Wizard from "@/pages/Wizard";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Admin from "@/pages/Admin";
import AdminMessages from "@/pages/AdminMessages";
import Revenue from "@/pages/Revenue";
import AdminPlans from "@/pages/AdminPlans";
import SubscriptionExpired from "@/pages/SubscriptionExpired";
import BillingGuard from "@/components/BillingGuard";
import Compliance from "@/pages/Compliance";
import ChatWidget from "@/components/ChatWidget";
import Privacy from "@/pages/Privacy";
import Community from "@/pages/Community";
import { Toaster } from "sonner";

const Guarded = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <div className="App dark bg-background text-foreground min-h-screen">
      <BrowserRouter>
        <ClerkAuthProvider>
          <LanguageProvider>
          <RoleProvider>
            <Toaster theme="dark" position="bottom-right" mobileOffset={{ bottom: 148 }} toastOptions={{ actionButtonStyle: { minHeight: 36, padding: "0 14px", fontWeight: 700 } }} />
            <PreviewBanner />
            <InstallPrompt />
            <BillingGuard />
            <Routes>
              <Route path="/subscription-expired" element={<Guarded><SubscriptionExpired /></Guarded>} />
              <Route path="/" element={<LanguageGateway />} />
              <Route path="/home" element={<Landing />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="/admin/messages" element={<AdminRoute><AdminMessages /></AdminRoute>} />
              <Route path="/admin/revenue" element={<AdminRoute><Revenue /></AdminRoute>} />
              <Route path="/admin/plans" element={<AdminRoute><AdminPlans /></AdminRoute>} />
              <Route path="/compliance" element={<Guarded><Compliance /></Guarded>} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
              <Route path="/wizard" element={<ClientRoute><Wizard /></ClientRoute>} />
              <Route path="/dashboard" element={<ClientRoute><Dashboard /></ClientRoute>} />
              <Route path="/chat" element={<Guarded><Chat /></Guarded>} />
              <Route path="/community" element={<Guarded><Community /></Guarded>} />
              <Route path="/pricing" element={<Guarded><Pricing /></Guarded>} />
              <Route path="/payment/success" element={<Guarded><PaymentSuccess /></Guarded>} />
              <Route path="/payment/cancel" element={<Guarded><PaymentCancel /></Guarded>} />
            </Routes>
            <ChatWidget />
          </RoleProvider>
          </LanguageProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
